import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import styles from './Home.module.css';
import { TextField } from "@material-ui/core";
import api from "../services/api";

import logoCasa from "../images/casa-logo.svg";
import { Toaster, toast } from 'sonner';

function Home() {
  const [documento, setDocumento] = useState('');
  const [captchaValido, setCaptchaValido] = useState(false);
  const [searching, setSearching] = useState(false);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (!documento || documento === "") return toast.warning("Obrigatório informar um documento.");
      if (documento.length < 11) return toast.warning("Documento inválido.");

      if (!captchaValido) return toast.warning("Por favor, complete o captcha.");

      setSearching(true);

      toast.info("Aguarde...");
      const response = await api.post("/pedidos/owner", { document: documento.replace(/\D/g, '') });
      if (response?.data?.success) {
        localStorage.setItem('orders', JSON.stringify(response.data));
        localStorage.setItem('loggedDateTime', new Date()?.toString());
        window.location.href = '/meus-pedidos';
      } else {
        toast.error("Ocorreu um erro ao buscar os pedidos. Por favor, tente novamente em breve.");
      }

    } catch (e) {
      console.log(e?.response);
      toast.error(e?.response?.data?.message || "Ocorreu um erro ao buscar seus pedidos. Por favor, tente novamente em breve.");
    } finally {
      setSearching(false);
    }
  };

  const formatarDocumento = (value) => {
    const digits = value.replace(/\D/g, '');

    if (digits.length <= 11) {
      return digits
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
    } else {
      return digits
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/\/(\d{4})(\d{1,2})$/, '/$1-$2');
    }
  };

  const handleDocumentoChange = (e) => {
    const formatted = formatarDocumento(e.target.value);
    setDocumento(formatted);
    localStorage.setItem('documento', formatted);
  };


  return (
    <div className={styles.page}>
      <main className={styles.container}>
        <div className={styles.containerChildren}>
          {/* <div className={styles.informations}>
            <h1 className={styles.welcome}>
              Bem-vindo ao nosso rastreio!
            </h1>
            <p className={styles.description}>
              Informe seu documento para visualizar os pedidos.
            </p>
          </div> */}
          <div className={styles.logos}>
            <a
              href="https://www.abracasa.com.br/"
              target="_blank"
              rel="noreferrer noopener"
              className={styles.logoLink}
            >
              <img
                className={styles.logo}
                src={logoCasa}
                alt="Abra Casa"
              />
            </a>
            <div className={styles.firstStep}>
              Da nossa casa para a sua.
            </div>
          </div>
        </div>
        <div className={styles.pipe}></div>
        <div className={styles.formWrapper}>
          <button
            className={styles.backButton}
            onClick={() => window.open('https://www.abracasa.com.br/institucional/nossas-lojas', '_blank')}
            aria-label="Voltar para página inicial"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" role="img" aria-label="Localização">
              <title>Localização</title>
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
              <circle cx="12" cy="9" r="2.5" fill="currentColor" />
            </svg>
            <span>Nossas lojas</span>
          </button>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formHeader}>
              <h2 className={styles.formTitle}>Acesse seus pedidos</h2>
              <p className={styles.formSubtitle}>Digite seu CPF ou CNPJ para continuar</p>
            </div>
            <div className={styles.inputWrapper}>
              <TextField
                id="document"
                label="CPF/CNPJ"
                variant="outlined"
                size="small"
                value={documento}
                onChange={handleDocumentoChange}
                className={styles.textField}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  maxLength: 18,
                }}
              />
            </div>

            <div className={styles.captchaContainer}>
              <ReCAPTCHA
                sitekey="6LedhJAqAAAAAKJVr3WL_yLTVY5G4cbzZ40KNoxH"
                onChange={() => setCaptchaValido(true)}
              />
            </div>

            <button
              type="submit"
              className={styles.button}
              onClick={(e) => handleSubmit(e)}
              disabled={searching}
            >
              {searching ? (
                <>
                  <span className={styles.buttonLoader}></span>
                  Buscando...
                </>
              ) : (
                'Buscar'
              )}
            </button>
          </form>
        </div>
        <div className={styles.logosMobile}>
          <div className={styles.header}>
            <a
              href="https://www.abracasa.com.br/"
              target="_blank"
              rel="noreferrer noopener"
              className={styles.logoLink}
            >
              <img
                className={styles.logo}
                src={logoCasa}
                alt="Abra Casa"
              />
            </a>
            <button
              className={styles.backButton}
              onClick={() => window.open('https://www.abracasa.com.br/institucional/nossas-lojas', '_blank')}
              aria-label="Voltar para página inicial"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15" role="img" aria-label="Localização">
                <title>Localização</title>
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                  fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                <circle cx="12" cy="9" r="2.5" fill="currentColor" />
              </svg>
              <span>Nossas lojas</span>
            </button>
          </div>
        </div>
      </main>
      <Toaster />
    </div>
  );
}

export default Home; 